import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Eyebrow } from "./Reveal";

const lineVariants = {
    hidden: { y: "115%" },
    visible: (i) => ({
        y: 0,
        transition: { duration: 0.85, delay: 0.15 + i * 0.13, ease: [0.22, 1, 0.36, 1] },
    }),
};

export default function PageHero({ eyebrow, crumb, titleLines, lead }) {
    return (
        <section className="relative overflow-hidden bg-navy-dark text-white">
            <div className="absolute inset-0 bg-blueprint" aria-hidden="true" />
            <div
                className="absolute -right-24 top-0 hidden h-full w-1/3 opacity-40 md:block"
                aria-hidden="true"
                style={{
                    backgroundImage:
                        "radial-gradient(circle at 70% 30%, rgba(225,29,72,0.18), transparent 55%)",
                }}
            />
            <div className="relative mx-auto max-w-7xl px-4 pb-16 pt-28 sm:px-6 md:pb-20 md:pt-36 lg:px-8">
                <motion.p
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.5 }}
                    className="font-mono text-[11px] uppercase tracking-[0.22em] text-slate-400"
                >
                    <Link to="/" className="transition-colors hover:text-white" data-testid="breadcrumb-home-link">
                        Home
                    </Link>
                    <span className="mx-2 text-brand-red">/</span>
                    {crumb}
                </motion.p>
                <h1 className="mt-6 max-w-4xl text-4xl font-bold leading-[1.05] tracking-tight sm:text-5xl md:text-6xl">
                    {titleLines.map((line, i) => (
                        <span key={i} className="block overflow-hidden pb-1">
                            <motion.span
                                className="block"
                                custom={i}
                                variants={lineVariants}
                                initial="hidden"
                                animate="visible"
                            >
                                {line}
                            </motion.span>
                        </span>
                    ))}
                </h1>
                {lead && (
                    <motion.p
                        initial={{ opacity: 0, y: 16 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.55 }}
                        className="mt-6 max-w-2xl text-base leading-relaxed text-slate-300 md:text-lg"
                    >
                        {lead}
                    </motion.p>
                )}
                <div className="mt-8">
                    <Eyebrow light>{eyebrow}</Eyebrow>
                </div>
            </div>
            <div className="relative h-1 w-full bg-brand-red" aria-hidden="true" />
        </section>
    );
}
